import React from 'react';
import CarouselMarcas from '../components/Inicio/CarouselMarcas';
import BannerInicio from '../components/Inicio/BannerInicio';
import NuestrosServicios from '../components/Inicio/NuestrosServicios';
import ProductosDestacados from '../components/Inicio/ProductosDestacados';
import MarcasDestacadas from '../components/Inicio/MarcasDestacadas';
import MapaUbicacion from '../components/Inicio/MapaUbicacion';


const Inicio = () => {
  const banner = 'https://agroh.info/imagenes/extras/bannerInicio.jpg';
  return (
    <div className='min-w-screen flex flex-col items-center'>
      <CarouselMarcas />
      <BannerInicio img={banner} texto={"La mejor solución para tu campo."}/>
      <div className='min-h-screen w-full bg-GrisClaro flex flex-col items-center justify-center'>
        <div className='w-11/12 min-h-screen bg-Blanco mt-5 mb-5 flex flex-col p-10'>
          <ProductosDestacados />
          <NuestrosServicios/>
          <MarcasDestacadas />
        </div>
      <div className='w-11/12 flex justify-center mb-5'>
          <MapaUbicacion/>
      </div>
      </div>
    </div>
  );
};

export default Inicio;
